(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('.metraink-page-header');
    const toggle = header?.querySelector('.metraink-menu-toggle');
    const navigation = header?.querySelector('nav');
    toggle?.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      navigation?.classList.toggle('open', !expanded);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
